<template>
	<input type="hidden"
		   v-on:focus="$event.target.select()"
		   ref="clipboardText"
		   readonly
		   :value="text"/>
	<button @click.prevent="copy" class="btn btn-sm btn-outline-secondary rounded">
		<i class="fe fe-copy"></i>
	</button>
</template>

<script>
	export default {

		props: ['text'],

		methods: {
			copy() {
				this.$refs.clipboardText.focus();
				document.execCommand('copy');
			}
		}

	}
</script>
